import React from 'react';
import { useTranslation } from "react-i18next"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack, Typography, Container } from "@mui/material";
import { AccordionComponent } from "./commons/AccordionComponent.jsx"
import Parser from 'html-react-parser';

export const QuestionaryLevelInfo = () => {
    const { t } = useTranslation()
    return (
        <Stack spacing={1}>
            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.seguridadInformacionTitle") + "</b>")} text={t("SeleccionarModoCuestionario.seguridadInformacionText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.gestionActivosTitle") + "</b")} text={t("SeleccionarModoCuestionario.gestionActivosText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.controlAccesoTitle") + "</b")} text={t("SeleccionarModoCuestionario.controlAccesoText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.concienciacionCapacitacionTitle") + "</b")} text={t("SeleccionarModoCuestionario.concienciacionCapacitacionText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.proteccionRedesSistemasTitle") + "</b")} text={t("SeleccionarModoCuestionario.proteccionRedesSistemasText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.gestionVulnerabilidadesTitle") + "</b")} text={t("SeleccionarModoCuestionario.gestionVulnerabilidadesText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.monitorizacionTitle") + "</b")} text={t("SeleccionarModoCuestionario.monitorizacionText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.copiaSeguridadTitle") + "</b")} text={t("SeleccionarModoCuestionario.copiaSeguridadText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.gestionProveedoresTitle") + "</b")} text={t("SeleccionarModoCuestionario.gestionProveedoresText")} />

            <AccordionComponent title={Parser("<b>" + t("SeleccionarModoCuestionario.cumplimientoNormativoTitle") + "</b")} text={t("SeleccionarModoCuestionario.cumplimientoNormativoText")} />

        </Stack>
    );
}

export default QuestionaryLevelInfo;